import React from 'react'
import { Flex, Label, Input, Button, Table, useDebounce } from '@fareye/ui'
import { FaDownload, isEmpty, dMmm } from '@fareye/utils'
import { downloadToCSV, useTranslation } from '@fareye/common'

import { getTableColumns } from './Column'

const style: any = {
  tripTabs: {
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
    backgroundColor: '#FFFFFF',
    padding: '12px',
    height: 'fit-content'
  },
  downloadIcon: {
    marginLeft: '8px'
  },
  mode: {
    borderRadius: '4px',
    padding: '8px',
    backgroundColor: '#DADADA',
    width: 'fit-content',
    marginBottom: '8px'
  }
}

export const ItemDetails = ({ otherData, config, data }: any) => {
  const { items = [] } = otherData
  const { startLocation, endLocation } = data
  const { t } = useTranslation()
  const itemList = items.map((item: any) => {
    return {
      ...item,
      origin: startLocation?.locationName,
      destination: endLocation?.locationName
    }
  })
  const {
    config: { itemColumns }
  } = config
  const [searchInput, setSearchInput] = React.useState('')
  const debouncedSearchTerm = useDebounce(searchInput, 400)

  const [downloadLoading, setDownloadLoading] = React.useState(false)

  const [filteredData, setFilteredData] = React.useState([])

  const selectedColumn = React.useMemo(() => {
    return getTableColumns(itemColumns, {
      t,
      queryParams: {}
    })
  }, [])
  React.useEffect(() => {
    setFilteredData(
      isEmpty(searchInput)
        ? itemList
        : itemList.filter((item: any) =>
            Object.values(item).includes(searchInput)
          )
    )
  }, [debouncedSearchTerm])
  let translatedItemList = itemList
  translatedItemList = translatedItemList.map((item: any) => {
    return {
      ...item,
      itemId: t(item.itemId),
      itemName: t(item.itemName)
    }
  })
  return (
    <Flex column>
      <Flex style={style.tripTabs} column>
        <Label style={{ fontSize: '16px', fontWeight: 600 }}>
          {t('Item Details')}
        </Label>
        <Flex justifyContentSpaceBetween>
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setSearchInput(e.target.value)
            }
            placeholder={t('Search Items')}
            style={{
              margin: '15px 0px 4px',
              fontSize: 12,
              lineHeight: 1,
              background: '#fff',
              borderColor: 'hsl(0,0%,80%)',
              color: 'rgba(151,151,151,1)'
            }}
          />
          <Button
            disabled={false}
            isLoading={false}
            variant="s primary"
            style={{ height: '30px', margin: '15px 0px 4px' }}
            onClick={() => {
              setDownloadLoading(true)
              downloadToCSV({
                data: translatedItemList,
                fileName: `itemDetails_${dMmm()}`
              })
              setDownloadLoading(false)
            }}
          >
            {t('Download CSV')}
            <FaDownload style={style.downloadIcon} />
          </Button>
        </Flex>
      </Flex>
      {!isEmpty(filteredData) ? (
        <Flex style={style.tripTabs} column>
          <Table
            className="striped responsive"
            sortable={false}
            showTotalCount={false}
            totalElements={filteredData.length}
            data={filteredData}
            showPagination={false}
            columns={selectedColumn}
          />
        </Flex>
      ) : (
        <Label
          style={{
            width: '100%',
            paddingTop: '10vmax',
            textAlign: 'center',
            display: 'block'
          }}
        >
          No Data
        </Label>
      )}
    </Flex>
  )
}
